import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useStatisticDetail } from "./useStatisticDetail";
import { SummaryCards } from "./SummaryCards";
import { LinksTable } from "./LinksTable";
import { AnchorsTable } from "./AnchorsTable";

export function StatisticDetail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const targetUrl = searchParams.get("targetUrl") ?? "";
  const language = searchParams.get("language") ?? "";
  const region = searchParams.get("region") ?? "";

  const [activeTab, setActiveTab] = useState(0);

  const {
    summaryState,
    linksState,
    linksFetching,
    linksPage,
    linksPageSize,
    linksSearch,
    linksStatusFilter,
    linksSortField,
    linksSortDirection,
    anchorsState,
    anchorsFetching,
    anchorsPage,
    anchorsPageSize,
    anchorsSortField,
    anchorsSortDirection,
    setLinksPage,
    setLinksPageSize,
    setLinksSearch,
    setLinksStatusFilter,
    setLinksSort,
    setAnchorsPage,
    setAnchorsPageSize,
    setAnchorsSort,
    refetchLinks,
    refetchAnchors,
  } = useStatisticDetail({ targetUrl, language, region });

  return (
    <Box p={3}>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link
          component="button"
          underline="hover"
          color="inherit"
          onClick={() => {
      void navigate("/statistics");
    }}
        >
          Статистика
        </Link>
        <Typography color="text.primary">{targetUrl}</Typography>
      </Breadcrumbs>

      {summaryState.kind === "loading" && (
        <Box display="flex" justifyContent="center" p={6}>
          <CircularProgress />
        </Box>
      )}

      {summaryState.kind === "error" && (
        <Alert severity="error">
          Ошибка загрузки сводки: {summaryState.message}
        </Alert>
      )}

      {summaryState.kind === "data" && (
        <SummaryCards
          totalLinks={summaryState.summary.totalLinks}
          articleLinks={summaryState.summary.articleLinks}
          homepageLinks={summaryState.summary.homepageLinks}
          sitewideLinks={summaryState.summary.sitewideLinks}
          validLinks={summaryState.summary.validLinks}
          invalidLinks={summaryState.summary.invalidLinks}
          uncheckedLinks={summaryState.summary.uncheckedLinks}
          uniqueAnchors={summaryState.summary.uniqueAnchors}
          lastPublishedAt={summaryState.summary.lastPublishedAt}
        />
      )}

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs value={activeTab} onChange={(_event, newValue: number) => setActiveTab(newValue)}>
          <Tab label="Ссылки" />
          <Tab label="Анкоры" />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <LinksTable
          state={linksState}
          fetching={linksFetching}
          page={linksPage}
          pageSize={linksPageSize}
          search={linksSearch}
          statusFilter={linksStatusFilter}
          sortField={linksSortField}
          sortDirection={linksSortDirection}
          onPageChange={setLinksPage}
          onPageSizeChange={setLinksPageSize}
          onSearchChange={setLinksSearch}
          onStatusFilterChange={setLinksStatusFilter}
          onSortChange={setLinksSort}
          onRefetch={refetchLinks}
        />
      )}

      {activeTab === 1 && (
        <AnchorsTable
          state={anchorsState}
          fetching={anchorsFetching}
          page={anchorsPage}
          pageSize={anchorsPageSize}
          sortField={anchorsSortField}
          sortDirection={anchorsSortDirection}
          onPageChange={setAnchorsPage}
          onPageSizeChange={setAnchorsPageSize}
          onSortChange={setAnchorsSort}
          onRefetch={refetchAnchors}
        />
      )}
    </Box>
  );
}
